import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'
import { MedicalRequestForm } from 'components/MedicalRequestForm'
import { UserData } from 'models/Auth'
import { useSelector } from 'react-redux'
import MedicalRequestExampleImage from 'static/images/medical-request-example.webp'
import { ReactComponent as ArrowIcon } from 'static/svg/arrow-right.svg'
import { ReactComponent as SuccessIcon } from 'static/svg/green-check.svg'
import { ReactComponent as FulfilledAlertIcon } from 'static/svg/fulfilled-alert-icon.svg'
import { ReactComponent as LogoTelavitaColor } from 'static/svg/Logo Telavita Color.svg'
import * as routes from 'settings/_routesSettings'
import * as S from './styles'

type AlertFeedback = {
  message: string;
  type: 'success' | 'error';
};

export function RegisterMedicalRequest() {
  const { isMobile } = useDimensions()
  const history = useHistory()
  const [alertFeedback, setAlertFeedback] = useState<AlertFeedback>()
  const planSelected = useSelector(
    (state: UserData) => state.auth.planSelected
  )
  const userPlanGroup = planSelected.plan_group
  const userPlanCode = planSelected.partner_plan_code

  const firstName = useSelector(
    (state: UserData) => state.auth.userData.person_general.first_name
  )

  const handleSuccess = () => {
    setAlertFeedback({ message: 'Conta criada com sucesso!', type: 'success' })
    history.push(routes.REGISTER_ATTACH_MEDICAL_REQUEST_DONE)
  }

  const handleError = () => {
    setAlertFeedback({ message: 'Erro ao criar conta', type: 'error' })
  }

  return (
    <S.Container>
      <S.ContentSection>
        <S.MedicalRequestFormContainer>
          <S.LogoWrapper>
            <LogoTelavitaColor />
            {alertFeedback?.type && (
              <S.AlertContainer type={alertFeedback.type}>
                {alertFeedback.type === 'error' ? (
                  <FulfilledAlertIcon width={20} height={20} />
                ) : (
                  <SuccessIcon width={20} height={20} />
                )}
                <strong>{alertFeedback.message}</strong>
              </S.AlertContainer>
            )}
            <img
              src={userPlanGroup?.logo_url ?? ''}
              alt={userPlanGroup?.name ?? ''}
              width={115}
              height={62}
            />
          </S.LogoWrapper>
          <S.Title>
            <Typography>
              Para agendar uma consulta, seu convênio requer um pedido médico,{' '}
              {firstName}
            </Typography>
          </S.Title>
          <S.Description>
            <Typography weight="bolder">
              Não tem o pedido médico?{' '}
            </Typography>
            <Typography>
              Obtenha um agendando uma consulta online com um médico em seu convênio.
            </Typography>
            <Typography>
              <a href="https://conteudo.telavita.com.br/bradesco-como-solicitar-pedido-medico">
                <b>Saiba como</b>
              </a>
            </Typography>
          </S.Description>
          <MedicalRequestForm
            onSuccess={handleSuccess}
            onError={handleError}
            planCode={userPlanCode}
          />
        </S.MedicalRequestFormContainer>
      </S.ContentSection>
      {!isMobile && (
        <>
          <S.ImageSection>
            <S.MedicalRequestExampleContainer>
              <S.MedicalRequestExampleBackground
                src={MedicalRequestExampleImage}
                alt="Exemplo de pedido médico"
                loading="lazy"
              />
            </S.MedicalRequestExampleContainer>
          </S.ImageSection>
          <S.ChatHelper>
            <Typography>
              <strong>Dúvidas sobre pedido médico?</strong>
            </Typography>
            <Typography>Fale com a gente pelo chat</Typography>
            <ArrowIcon aria-hidden="true" />
          </S.ChatHelper>
        </>
      )}
    </S.Container>
  )
}
